export function getTimestamp(): string {
  return new Date().toISOString()
}
